import { setPageStateById } from '@/contexts/PageContext/PageContext';

export const setShowMobilePageRightMenu = (setState: setPageStateById) => (value: boolean) => {
  setState('SET_SHOW_MOBILE_PAGE_RIGHT_MENU', (s) => {
    return {
      ...s,
      showMobilePageRightMenu: value,
      showMobileLeftMenu: false,
    };
  });
};
